import React from "react";

export const KpiCard = ({
  Image,
  Alt,
  ColorDark,
  Title,
  Value,
  Padding,
  ImageSize,
  onclick,
  HightLight,
  subtext,
}) => {
  const content = (
    <div
      className={`grid grid-cols-[auto_1fr] ${Padding} text-white rounded-lg ${ColorDark} mt-2 md:mt-0 gap-2`}
    >
      <div className={`flex flex-col justify-center`}>
        <img
          src={Image}
          alt={Alt}
          className={`self-center ${ImageSize} justify-self-center`}
        />
        {subtext && <span className="text-[11px] text-center">{subtext}</span>}
      </div>
      <div className="grid items-center justify-center relative">
        {onclick && (
          <span className={`absolute ${HightLight} flex h-3 w-3`}>
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-600 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-600"></span>
          </span>
        )}
        <div className="text-sm font-semibold text-center">{Title}</div>
        <div className="text-3xl font-bold md:text-xl lg:text-3xl justify-self-center leading-5">
          {Value}
        </div>
      </div>
    </div>
  );

  if (onclick) {
    return (
      <div
        onClick={onclick}
        className="no-underline transition duration-300 ease-in-out transform hover:scale-105"
        title="Click here to View Detailed Summary"
      >
        {content}
      </div>
    );
  } else {
    return content;
  }
};
